import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import Tab from '../../../components/Tab';
import { transformDataColumns } from '../../../utils/transformDataColumns';

const header = defineMessages({
  title: {
    id: 'hubs.organizations-and-services.rotc.title',
    defaultMessage: 'ROTC Available',
  },
});

const messages = defineMessages({
  ROTCArmy: {
    id: 'hubs.organizations-and-services.rotc.ROTCArmy',
    defaultMessage: 'Army',
  },
  ROTCNavy: {
    id: 'hubs.organizations-and-services.rotc.ROTCNavy',
    defaultMessage: 'Navy',
  },
  ROTCAirforce: {
    id: 'hubs.organizations-and-services.rotc.ROTCAirforce',
    defaultMessage: 'Airforce',
  },
  ROTCServicepersonOpportunityCollege: {
    id: 'hubs.organizations-and-services.rotc.ROTCServicepersonOpportunityCollege',
    defaultMessage: 'Serviceperson Opportunity College',
  },
});

function ROTC({ intl, services }) {
  const [leftSide, rightSide] = transformDataColumns(services, services);

  return (
    <Tab.Pane>
      <h3>{intl.formatMessage(header.title)}</h3>
      <div className="row">
        <ul className="column">
          {leftSide.map(key => (
            <li key={key}>{intl.formatMessage(messages[key])}</li>
          ))}
        </ul>
        <ul className="column">
          {rightSide.map(key => (
            <li key={key}>{intl.formatMessage(messages[key])}</li>
          ))}
        </ul>
      </div>
    </Tab.Pane>
  );
}

ROTC.propTypes = {
  services: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(ROTC);
